<template>
  <SPCoreShell>
    <template #filter>
      <v-select class="mb-4" v-model="liveFilters.spp" :items="filterListData.sppList" item-text="name" item-value="id" label="Pharmacy" multiple outline hide-details />
      <v-select class="mb-4" v-model="liveFilters.patientHcp" :items="filterListData.patientHcpList" item-text="name" item-value="id" label="Provider" multiple outline hide-details />
      <v-select class="mb-4" v-model="liveFilters.patientInsurance" :items="filterListData.patientInsuranceList" item-text="name" item-value="id" label="Insurance" multiple outline hide-details />
      <v-treeselect class="spcore-states-treeselect" :value="selectedStates" :multiple="true" :options="states" placeholder="State" @input="stateSelected" />
      <DateRangePicker header="Date Range" :value="liveFilters.dateRange || { from: claimsDate.min, to: claimsDate.max }" :min="claimsDate.min" :max="claimsDate.max" @input="dateSelected" />
      <loader v-if="isFiltering.filterList" />
    </template>
    <SpcorePatientNotifications
      class="col-sm-12 col-lg-6 p-4"
      title="Pending Patients"
      :data="pendingPatientData"
      :filterObject="mergeFilter({ prescriber: null })"
      :isFiltering="isFiltering.pendingPatient"
      :image="$loadImage(patientPendingImage)"
      message="Prescription outside normal processing time"
      @refresh-data="loadPendingPatientData"
    />
    <SPCoreLineAreaChart
      class="flex sm12 lg6 p-4"
      title="Prescription Processing Time"
      :data="timeToFirstFillData"
      :filterObject="mergeFilter({ timeToFirstFill: null })"
      :isFiltering="isFiltering.timeToFirstFill"
      :selected="liveFilters.timeToFirstFill"
      @refresh-data="loadTimeToFirstFillData"
      @checked-changed="timeToFirstFillSelected"
    />
    <SpcorePatientNotifications
      class="col-sm-12 col-lg-6 p-4"
      title="Active Patients"
      :data="activePatientData"
      :filterObject="mergeFilter({ prescriber: null })"
      :isFiltering="isFiltering.activePatient"
      :image="$loadImage(patientActiveImage)"
      message="Current cases experiencing Gap in refill"
      @refresh-data="loadActivePatientData"
    />
    <SPCoreLineAreaChart
      class="flex sm12 lg6 p-4 mb-4"
      title="GAP Days"
      :data="timeToFirstFillData"
      :filterObject="mergeFilter({ timeToFirstFill: null })"
      :isFiltering="isFiltering.timeToFirstFill"
      :selected="liveFilters.timeToFirstFill"
      @refresh-data="loadTimeToFirstFillData"
      @checked-changed="timeToFirstFillSelected"
    />
  </SPCoreShell>
</template>
  
<script>
import axios from '../../axios';
import { getDemographics } from '../../libraries/cohorts';
import { stringifyLiveFilters } from '../../libraries/liveFilters';
import VTreeselect from '@riophae/vue-treeselect';
import DateRangePicker from '../../components/common/date/DateRangePicker.vue';
import SpcorePatientNotifications from '../../components/spcore/SpcorePatientNotifications.vue';
import SPCoreLineAreaChart from '../../components/spcore/SPCoreLineAreaChart.vue';
import SPCoreShell from '../../components/spcore/SPCoreShell.vue';
import patientPendingImage from '../../assets/images/Patientpending.png'
import patientActiveImage from '../../assets/images/Patient@2x.png'
import { mergeFilters } from '../../libraries/common';

export default {
  title: 'Patient Summary',
  components: { VTreeselect, DateRangePicker, SpcorePatientNotifications, SPCoreLineAreaChart, SPCoreShell, },
  data() {
    var states = getDemographics().states
      .reduce((acc, f) => { acc[f.value] = f.text; return acc; }, {});
    return {
      liveFilters: { area: {} },
      isFiltering: {},
      cancelRequest: {},
      pendingPatientData: [
        { text: 'Patients in pipeline', value: 0 },
        { text: 'Days', value: 0, alert: true }
      ],
      activePatientData: [
        { text: 'Patients on therapy', value: 0 },
        { text: 'Cases', value: 0, alert: true }
      ],
      claimsDate: { min: new Date('2015-01-01').toISOString(), max: new Date().toISOString() },
      timeToFirstFillData: { data: {}, labels: [] },
      filterListData: {},
      states: ['Mid West', 'North East', 'South East', 'South West', 'West']
        .map(region => ({
          id: region,
          label: region,
          children: getDemographics()[region]
            .map(f => ({ id: f, label: states[f] }))
        })),
      selectedStates: null,
      patientPendingImage,
      patientActiveImage,
    }
  },
  methods: {
    mergeFilter(obj) {
      return mergeFilters(this.liveFilters, obj);
    },

    loadPendingPatientData() {
      if (this.cancelRequest.pendingPatient)
        this.cancelRequest.pendingPatient();
      this.$set(this.isFiltering, 'pendingPatient', true);
      axios.post('/SPCore/PatientSummary/GetPatientSummary', {
        runId: this.runId,
        patientcomponent: "PendingPatient",
        ...stringifyLiveFilters(this.liveFilters),
      }, {
        cancelToken: new axios.CancelToken(c => this.cancelRequest.pendingPatient = c)
      }).then((response) => {

        this.pendingPatientData = [
          { text: 'Patients in pipeline', value: response.data.patientsInPipeline },
          { text: 'Days', value: response.data.alertDays, alert: true }
        ];
        this.isFiltering.pendingPatient = false;
      }).catch((error) => {
        if (!axios.isCancel(error)) {
          console.log(error);
          this.isFiltering.pendingPatient = false;
          this.disableIfTimeout(error);
        }
      });
    },

    dateSelected(event) {
      this.liveFilters = {
        ...this.liveFilters,
        dateRange: event
      };
    },

    loadActivePatientData() {
      if (this.cancelRequest.activePatient)
        this.cancelRequest.activePatient();
      this.$set(this.isFiltering, 'activePatient', true);
      axios.post('/SPCore/PatientSummary/GetPatientSummary', {
        runId: this.runId,
        patientcomponent: "ActivePatients",
        ...stringifyLiveFilters(this.liveFilters),
      }, {
        cancelToken: new axios.CancelToken(c => this.cancelRequest.activePatient = c)
      }).then((response) => {
        this.activePatientData = [
          { text: 'Patients on therapy', value: response.data.patientsOnTherapy },
          { text: 'Cases', value: response.data.alertCases, alert: true }
        ];
        this.isFiltering.activePatient = false;
      }).catch((error) => {
        if (!axios.isCancel(error)) {
          console.log(error);
          this.isFiltering.activePatient = false;
          this.disableIfTimeout(error);
        }
      });
    },


    loadTimeToFirstFillData(filterObject) {
      if (this.cancelRequest.timeToFirstFill)
        this.cancelRequest.timeToFirstFill();
      this.$set(this.isFiltering, 'timeToFirstFill', true);
      axios.post('/SPCore/PatientSummary/GetPatientSummary', {
        runId: this.runId,
        patientcomponent: "PrescriptionProcessingTime",
        ...stringifyLiveFilters(filterObject),
      }, {
        cancelToken: new axios.CancelToken(c => this.cancelRequest.timeToFirstFill = c)
      }).then((response) => {
        var emptyData = new Array(22).fill(0).reduce((acc, f, ind) => { acc[ind] = 0; return acc; }, []);
        var data = response.data.reduce((acc, f) => {
          if (f.noOfDays >= 21) {
            acc[21] += f.patientCount;
          } else {
            acc[f.noOfDays - 1] += f.patientCount;
          }
          return acc;
        }, emptyData);
        this.timeToFirstFillData = {
          // @ts-ignore
          labels: Object.keys(data).head().concat(['>=21', '>=21']),
          data: {
            Patients: Object.keys(data).map(key => ({ x: key, y: data[key] })).concat({ x: '22', y: data[21] })
          },
          originalData: response.data,
          pieces: [
            { gt: 0, lt: 7, color: 'green' },
            { gt: 7, lt: 13, color: 'yellow' },
            { gt: 13, lt: 20, color: 'orange' },
            { gt: 21, lt: 22, color: 'red' }
          ],
        }
        this.isFiltering.timeToFirstFill = false;
      }).catch((error) => {
        if (!axios.isCancel(error)) {
          console.log(error);
          this.isFiltering.timeToFirstFill = false;
          this.disableIfTimeout(error);
        }
      });
    },
    timeToFirstFillSelected(event) {
      var shouldAdd = !(this.liveFilters.lastStatus || []).includes(event.filterValue);
      this.$set(this.liveFilters, 'lastStatus', (this.liveFilters.lastStatus || []).filter(f => f !== event.filterValue));
      if (shouldAdd)
        this.liveFilters.lastStatus.push(event.filterValue);
    },

    loadFilterListData() {
      if (this.cancelRequest.filterList)
        this.cancelRequest.filterList();
      this.$set(this.isFiltering, 'filterList', true);
      axios.post('/SPCore/PatientSummary/GetPatientSummary', {
        runId: this.runId,
        PatientComponent: "FilterListData",
      }, {
        cancelToken: new axios.CancelToken(c => this.cancelRequest.filterList = c)
      }).then((response) => {
        this.filterListData = response.data;
        this.isFiltering.filterList = false;
      }).catch((error) => {
        if (!axios.isCancel(error)) {
          console.log(error);
          this.isFiltering.filterList = false;
          this.disableIfTimeout(error);
        }
      });
    },


    stateSelected(event) {
      var states = event.map(f => this.states.find(g => g.id === f) || f)
        .flatMap(f => f.children || [f])
        .map(f => f.id || f);
      this.liveFilters = {
        ...this.liveFilters,
        area: {
          ...this.liveFilters.area,
          states
        }
      };
    },
    disableIfTimeout(error) {
      if (error.response.status === 504) {
        this.alert('Error', 'Loading of data failed. Please reload page to try loading data again.');
      }
    },
  },
  computed: {
    isFilteringAny() {
      return Object.keys(this.isFiltering).find(key => this.isFiltering[key]);
    },
  },
  mounted() {
    if (process.env.NODE_ENV === 'development') window['thisSPCorePatientSummary'] = this;
    this.loadFilterListData();
  },
}
</script>
